import React from 'react';
import styled, { keyframes } from 'styled-components';

// Blue Screen of Death — triggered by Ctrl+Shift+B
// Shows the classic XP BSoD with Dead Simple Computing branding

function BSoD({ onDismiss }) {
    return (
        <Screen onClick={onDismiss}>
            <Content>
                <Title>A problem has been detected and Windows has been shut down to prevent damage
                    to your computer.</Title>

                <Para>
                    DRIVER_IRQL_NOT_LESS_OR_EQUAL
                </Para>

                <Para>
                    If this is the first time you've seen this Stop error screen,
                    restart your computer. If this screen appears again, follow
                    these steps:
                </Para>

                <Para>
                    Check to make sure any new hardware or software is properly installed.
                    If this is a new installation, ask your hardware or software manufacturer
                    for any Windows updates you might need.
                </Para>

                <Para>
                    If problems continue, disable or remove any newly installed hardware
                    or software. Disable BIOS memory options such as caching or shadowing.
                    If you need to use Safe Mode to remove or disable components, restart
                    your computer, press F8 to select Advanced Startup Options, and then
                    select Safe Mode.
                </Para>

                <Para>
                    Or better yet, call Dead Simple Computing on 0118 359 2220
                    and let the professionals handle it.
                </Para>

                <Para>
                    Technical information:
                </Para>

                <Para>
                    *** STOP: 0x000000D1 (0x0000000C,0x00000002,0x00000000,0xF86B5A89)
                </Para>

                <Para>
                    ***   ntoskrnl.exe - Address F86B5A89 base at F8681000, DateStamp 3e82830a
                </Para>

                <BlinkLine>
                    Press any key to dismiss this screen, or call 0118 359 2220 for actual help_
                </BlinkLine>
            </Content>
        </Screen>
    );
}

const blink = keyframes`
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
`;

const Screen = styled.div`
  position: fixed;
  inset: 0;
  background: #0000AA;
  z-index: 9999999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  cursor: pointer;
  font-family: 'Lucida Console', 'Courier New', monospace;
  overflow: auto;
`;

const Content = styled.div`
  color: #AAAAAA;
  font-size: 13px;
  line-height: 1.6;
  max-width: 750px;
  white-space: pre-wrap;
`;

const Title = styled.div`
  color: #FFFFFF;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Para = styled.div`
  margin-bottom: 14px;
  color: #CCCCCC;
`;

const BlinkLine = styled.div`
  color: #FFFFFF;
  margin-top: 30px;
  animation: ${blink} 1s step-end infinite;
`;

export default BSoD;
